
















prismic = require '@/utils/prismic/api'
{ textOf } = require '@/utils/prismic/utils'
PrismicDOM = require 'prismic-dom'

module.exports =
    props: ['copy']

    computed:
        allCopy: ->
            return PrismicDOM.RichText.asHtml(@copy)




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/home/about.vue